import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { AccountYTManagerAPI } from '../../services/ytmanager/accountYTManagerAPI';
import { BackgroundMusicAPI } from '../../services/backgroundMusicAPI';
import {CaseStudyBase} from '../base/caseStudy';
import { FontAPI } from '../../services/fontAPI';
import { CaseStudyYTManagerAPI } from '../../services/ytmanager/caseStudyYTManagerAPI';
import { EnvironmentService } from '../../services/environmentService';

@inject(AuthService, UserMessageService, Router, BackgroundMusicAPI, FontAPI, AccountYTManagerAPI, CaseStudyYTManagerAPI, EnvironmentService)
export class VideoDetails extends CaseStudyBase {
    constructor(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, api, envService) {
        super(authService, userMessageService, router, bgMusicApi, fontApi, accountApi, "api/youtubeManager", api, envService, true);
        this.fileBase = '';
        this.dashboardlength = 'col-sm-12';
        this.isdashboard = false;
    }

    activate(params, route) {

        super.activate(params, route);
        if(!params.id && params.account_owner_id) {
            this.account_owner_user_id = params.account_owner_id;
        }

        if(this.id) {
            this.api.getFileList(
                this.id, 
                this.authService.getUser().token,
                this.getFileListSuccess.bind(this),
                this.saveLoadError.bind(this));
        }

        this.captureOverride_files = [];
        
    }

    reset() {
       

        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
                super.reset();
            }, 
            this.saveLoadError.bind(this));
    }

    setData(data) {
        super.setData(data);

        this.accountApi.getUserData(
            this.account_owner_user_id,  
            this.authService.getUser().token, 
            (userData) => {
                this.account_org_phone = userData.account.org_phone;
                this.account_org_email = userData.account.org_email;
                this.account_website = userData.account.website;
            }, 
            this.saveLoadError.bind(this));

        this.capture_override_1 = data.capture_override_1;
        this.capture_override_2 = data.capture_override_2;
        this.capture_override_3 = data.capture_override_3;

        this.api.getFileList(
            this.id, 
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    reproduce(setReady = false) {
        this.saving = true;
        var data = this.getData();
        data.set_ready = setReady;
        this.api.reproduce(
            data,
            (this.cta_files && this.cta_files.length > 0 && this.showCTAUpload ? this.cta_files[0] : null),
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
    }

    getFileListSuccess(files) {
        this.files = files;

        this.fileBase = this.apiBase + "/caseStudy/downloadFile/" + this.id;
        

    }

    uploadCaptureOverride(num) {
        if (this.captureOverride_files[num - 1] && this.captureOverride_files[num - 1].length > 0) {
            this.saving = true;
            this.api.saveCaptureOverride(this.id, num,
                this.captureOverride_files[num - 1][0],
                this.authService.getUser().token,
                () => {this.overrideCaptureChanged(num, true)},
                (msg) => { this.userMessageService.setUserError("user", msg)});
        }
    }

    removeCaptureOverride(num) {
        this.saving = true;
        this.api.removeCaptureOverride(this.id, num,
            this.authService.getUser().token,
            () => {this.overrideCaptureChanged(num, false)},
            (msg) => { this.userMessageService.setUserError("user", msg)});
    }

    overrideCaptureChanged(num, capture_override) {
        this.userMessageService.setUserMessage("user", "Saved!");

        this.saving = false;

        switch(num) {
            case 1:
                this.capture_override_1 = capture_override;
            break;
            case 2:
                this.capture_override_2 = capture_override;
            break;
            case 3:
                this.capture_override_3 = capture_override;
            break;
        }
      
        this.api.getFileList(
            this.id, 
            this.authService.getUser().token,
            this.getFileListSuccess.bind(this),
            (msg) => { this.userMessageService.setUserError("user", msg)});

    }
    onNavigate() {
        this.navPanelClass = '';
      }
    

    navigateLink(route, replace = false) {
        console.log("route param123",route);
        localStorage.setItem('rout', route);
        if(route.includes("#/user/video/email"))
        {
          if(route.includes("upload"))
          route = route + "?captureType=3" + "?videoUpload=1";
          else
          route = route + "?captureType=3";
          // window.location.href = "Posts?Category=" + sel;
        }
        if(route.includes("#/user/home") || route == "#/user" || route === "#/user/video/request" || route === "#/user/video/caseStudy" || route.includes("#/user/video/email"))
        {
          this.isdashboard = true;
          this.dashboardlength = 'col-sm-12';
          console.log("Dashboard value is",this.isdashboard);
          // window.location.href = "Posts?Category=" + sel;
        }
        else
        {
          this.isdashboard = false;
          this.dashboardlength = 'col-sm-9';
          console.log("Dashboard value is",this.isdashboard);
        }
        this.router.navigate(route, { replace: replace });
        this.onNavigate();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
}
